import React from 'react';

interface ImportButtonProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export default function ImportButton({ onClick }: ImportButtonProps) {
  return (
    <button type="button" className="import-btn btn btn--curved" onClick={onClick}>
      Import
    </button>
  );
}
